'use strict';

export const TYPE_DASHBOARD = 'dashboard';
export const TYPE_BASELINE_GRAPH = 'baseline-graph';
export const TYPE_PROVISIONAL_BILL = 'provisional-bill';
export const TYPE_REPORT = 'report';
